module.exports = require('./helpers/bundle-url').getBundleURL('hlUsn') + "logo-dark.ba5147f0.svg";